import { createContext, FormEvent, MouseEvent, useState } from "react";

export interface IDashBoardContextProps {
  children: JSX.Element;
}

const DashContext = createContext<any>({});

export function DashboardProvider({ children }: IDashBoardContextProps) {
  const [showDashboard, setShowDashboard] = useState(false);
  const [removeFooter, setRemoveFooter] = useState(false);
  const [searching, setSearching] = useState(false);
  const [onGlobalSearch, setOnGlobalSearch] = useState<
    (e: FormEvent<HTMLInputElement>) => void
  >(() => (_: FormEvent<HTMLInputElement>) => {});
  const [showOnlyLogout, setShowOnlyLogout] = useState(false);
  const [selectedInventories, setSelectedInventories] = useState<any[]>([]);
  const [onGlobalFilter, setOnGlobalFilter] = useState<
    (e: MouseEvent<HTMLElement>) => void
  >(() => (_: MouseEvent<HTMLElement>) => {});
  const [showMessagesPopup, setShowMessagesPopup] = useState(false);
  const [showNotificationsPopup, setShowNotificationsPopup] = useState(false);

  return (
    <DashContext.Provider
      value={{
        showDashboard,
        setShowDashboard,
        onGlobalSearch,
        setOnGlobalSearch,
        searching,
        setSearching,
        showOnlyLogout,
        setShowOnlyLogout,
        selectedInventories,
        setSelectedInventories,
        onGlobalFilter,
        setOnGlobalFilter,
        removeFooter,
        setRemoveFooter,
        showMessagesPopup,
        setShowMessagesPopup,
        showNotificationsPopup,
        setShowNotificationsPopup,
      }}
    >
      {children}
    </DashContext.Provider>
  );
}

export default DashContext;
